import { BaseOrderlessAction, BaseOrderlessState } from 'components/CustomerSupportForms/Utils';
import { hasElements, rm } from 'utils';
import { isValidEmail, isValidPhoneNumber } from 'views/CheckoutPage/validation';
import {
  BaseZendeskFormAction,
  BaseZendeskFormState,
  BaseZendeskAction,
  BaseZendeskState
} from './types';

export const validateSubject = (
  { subject }: BaseZendeskState,
  dispatch: (action: BaseZendeskAction) => void
) => {
  const isSubjectEmpty = subject === undefined;
  if (isSubjectEmpty) {
    dispatch({
      type: 'subjectError',
      value: rm(
        'customerservice_shared_error_general_part',
        rm('customerservice_question_casetype').toLowerCase()
      )
    });
  }

  return !isSubjectEmpty;
};

export const validateQuestion = (
  { question }: BaseZendeskState,
  dispatch: (action: BaseZendeskAction) => void
) => {
  const isQuestionEmpty = question === '';

  if (isQuestionEmpty) {
    dispatch({
      type: 'questionError',
      value: rm('customerpage_deliveries_question_error')
    });
  }

  return !isQuestionEmpty;
};

export const validateEmailAndPhone = (
  { email, phone }: BaseOrderlessState,
  dispatch: (action: BaseOrderlessAction) => void
) => {
  if (!isValidEmail(email) || !isValidPhoneNumber(phone)) {
    dispatch({
      type: 'addressError',
      value: rm('CustomerService_Quote_Request_Address_Validation_Error')
    });

    return false;
  }

  dispatch({
    type: 'addressError',
    value: ''
  });

  return true;
};

export const validateProducts = (
  { products }: BaseZendeskFormState,
  dispatch: (action: BaseZendeskFormAction) => void
) => {
  const hasSelectedProduct = products.some(product => product.quantity > 0);
  if (!hasElements(products) || !hasSelectedProduct) {
    dispatch({
      type: 'productsError',
      value: rm('customerpage_returns_validation_error_products')
    });
    return false;
  }

  return true;
};
